class BadgeTextCircle extends HTMLElement {
  connectedCallback() {
    this._resizeHandler = () => {
      requestAnimationFrame(() => {
        this.fitText(this, 8, 22);
      });
    };

    window.addEventListener('resize', this._resizeHandler);

    // Initial run
    requestAnimationFrame(() => {
      this.fitText(this, 8, 22);
    });
  }

  disconnectedCallback() {
    // Clean up when element is removed
    window.removeEventListener('resize', this._resizeHandler);
  }

  fitText(element, minFont = 8, maxFont = 22) {
    let fontSize = maxFont;
    element.style.fontSize = `${fontSize}px`; 

    while (
      (element.scrollHeight > element.clientHeight ||
        element.scrollWidth > element.clientWidth) &&
      fontSize > minFont
    ) {
      fontSize--;
      element.style.fontSize = `${fontSize}px`;
    }
  }
}

customElements.define('badge-text-circle', BadgeTextCircle);
